export default __webpack_public_path__ + "static/media/22.3d42ff79.png";